import { useDashboard } from "@/lib/store";
import { environment } from "@/lib/constants";
import {
  Select,
  SelectValue,
  SelectTrigger,
  SelectItem,
  SelectContent,
} from "../ui/select";

export function ServerSelector() {
  const { server, setServer } = useDashboard();

  // Map the current server URL to 'eu' or 'asia'
  const serverValue = server === environment.socketUrl.asia ? "asia" : "eu";

  return (
    <div className="pl-2 w-24 h-8">
      <Select value={serverValue} onValueChange={setServer}>
        <SelectTrigger className="h-8 focus:ring-0 focus:ring-offset-0">
          <SelectValue placeholder="Select a server" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="eu">EU</SelectItem>
          <SelectItem value="asia">Asia</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
